import {
  SERVICEFORMCLOSE_REQUEST,
  SERVICEFORMCLOSE_SUCCESS,
  SERVICEFORMCLOSE_FAILURE,
  FORCECLOSEREQUEST_REQUEST,
  FORCECLOSEREQUEST_SUCCESS,
  FORCECLOSEREQUEST_FAILURE,
  SERVICEFAILEDCALLS_REQUEST,
  SERVICEFAILEDCALLS_SUCCESS,
  SERVICEFAILEDCALLS_FAILURE,
  SERVICEFAILEDCALLSCount_SUCCESS,
} from './constants';

import {combineReducers} from 'redux';

const isFetchingServices = (state = false, action) => {
  switch (action.type) {
    case SERVICEFORMCLOSE_REQUEST:
      return true;
    case SERVICEFORMCLOSE_SUCCESS:
    case SERVICEFORMCLOSE_FAILURE:
      return false;
    default:
      return state;
  }
};

const isFetchingFailedCalls = (state = false, action) => {
  switch (action.type) {
    case SERVICEFAILEDCALLS_REQUEST:
      return true;
    case SERVICEFAILEDCALLS_SUCCESS:
    case SERVICEFAILEDCALLS_FAILURE:
      return false;
    default:
      return state;
  }
};

const dataServices = (state = null, action) => {
  switch (action.type) {
    case SERVICEFORMCLOSE_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const faileddataServices = (state = null, action) => {
  switch (action.type) {
    case SERVICEFAILEDCALLS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const failureServices = (state = null, action) => {
  switch (action.type) {
    case SERVICEFORMCLOSE_FAILURE:
      return action.payload;
    default:
      return state;
  }
};

const hasServiceFetched = (state = false, action) => {
  switch (action.type) {
    case SERVICEFORMCLOSE_REQUEST:
      return false;
    case SERVICEFORMCLOSE_SUCCESS:
    case SERVICEFORMCLOSE_FAILURE:
      return true;
    default:
      return state;
  }
};
const isClosingServiceForm = (state = false, action) => {
  switch (action.type) {
    case FORCECLOSEREQUEST_REQUEST:
      return true;
    case FORCECLOSEREQUEST_SUCCESS:
    case FORCECLOSEREQUEST_FAILURE:
      return false;
    default:
      return state;
  }
};

const closingServiceData = (state = null, action) => {
  switch (action.type) {
    case FORCECLOSEREQUEST_SUCCESS:
      return action;
    default:
      return state;
  }
};

const failureServiceClose = (state = false, action) => {
  switch (action.type) {
    case FORCECLOSEREQUEST_FAILURE:
      return action.payload;
    default:
      return state;
  }
};

const failedCallsDataCount = (state = null, action) => {
  switch (action.type) {
    case SERVICEFAILEDCALLSCount_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const failedCallsData = (state = null, action) => {
  switch (action.type) {
    case SERVICEFAILEDCALLS_REQUEST:
      return true;
    case SERVICEFAILEDCALLS_SUCCESS:
    case SERVICEFAILEDCALLS_FAILURE:
      return false;
    default:
      return state;
  }
};

const hasServiceForceClosed = (state = false, action) => {
  switch (action.type) {
    case FORCECLOSEREQUEST_SUCCESS:
      return true;
    default:
      return state;
  }
};
export default combineReducers({
  isFetchingServices,
  dataServices,
  failureServices,
  hasServiceFetched,
  hasServiceForceClosed,
  failureServiceClose,
  isClosingServiceForm,
  closingServiceData,
  failedCallsData,
  failedCallsDataCount,
  isFetchingFailedCalls,
  faileddataServices,
});
